'use client';

import { navLinks } from '@/components/Header/helpers';
import { MobileMenu, Button, CustomRainbowButton } from '@/components';
import clsx from 'clsx';
import Image from 'next/image';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { DropdownNavMenu } from '@/components/Header/components/DropdownNavMenu';
import localConfig from '@/config';
import { useMemo } from 'react';

export const Header = () => {
  const currentRoute = usePathname();
  const isBridgePage = currentRoute?.includes('bridge');
  const isInIframe = useMemo(() => {
    if (typeof window === 'undefined') return true;
    return window.self !== window.top;
  }, [window]);
  const links = navLinks(isInIframe);

  return (
    <header className="sticky top-0 z-50 border-neutral-900 border-b h-[80px] bg-neutral-black px-4 lg:px-0">
      <div className="h-full flex items-center justify-between max-w-[1200px] mx-auto">
        <div className="flex items-center h-full">
          <MobileMenu className="flex lg:hidden" />
          <Link
            className="shrink-0"
            target="_blank"
            href={localConfig.isSynth ? 'https://www.synthdata.co/' : 'https://mode.network/'}
          >
            <Image
              className="w-[130px]"
              src={localConfig.isSynth ? '/synth-logo.svg' : '/mode-logo.svg'}
              alt="logo"
              width={132}
              height={40}
              priority
            />
          </Link>
          <div className="space-x-2 hidden lg:flex items-center lg:ml-[64px]">
            {links.map(({ text, href, disabled, show, children, target, icon }) => {
              if (show) {
                if (children && children.length > 0) {
                  return <DropdownNavMenu key={`${text}-${href}`} name={text} items={children} />;
                }
                if (icon) {
                  return (
                    <Link href={href} target={target} key={text}>
                      <div className="p-2 w-8 h-8 flex items-center justify-center">
                        <Image className="w-full" src={icon} alt={text} width={24} height={24} />
                      </div>
                    </Link>
                  );
                }

                return (
                  <Link
                    key={text}
                    href={href}
                    target={target}
                    className={clsx(
                      disabled && 'pointer-events-none text-neutral-600',
                      currentRoute?.includes(href) && 'text-primary',
                      'hover:bg-primary/8 hover:border-primary/8',
                      'flex items-center gap-2 p-2 text-neutral-100 font-medium border border-transparent rounded-lg uppercase text-sm xl:text-base'
                    )}
                  >
                    {text}
                  </Link>
                );
              }

              return null;
            })}
          </div>
        </div>
        {localConfig.isSynth ? (
          <Link href="https://www.synthdata.co/#contact" target="_blank">
            <Button>Get access</Button>
          </Link>
        ) : (
          <>{!isBridgePage && <CustomRainbowButton />}</>
        )}
      </div>
    </header>
  );
};
